var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.737 9.263a1.75 1.75 0 0 1 0 2.474l-21 21a1.75 1.75 0 1 1-2.474-2.474l21-21a1.75 1.75 0 0 1 2.474 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.263 9.263a1.75 1.75 0 0 1 2.474 0l21 21a1.75 1.75 0 1 1-2.474 2.474l-21-21a1.75 1.75 0 0 1 0-2.474Z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;